"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transitionUp = exports.transitionDown = exports.OverlayWrapper = exports.Overlay = exports.OVERLAY_ANIMATION = exports.HeaderWrapper = exports.FooterWrapper = exports.DialogWrapper = exports.DialogInnerWrapper = exports.Dialog = exports.DIALOG_ANIMATION = exports.ContentWrapper = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _dialog = require("@reach/dialog");

var _styledSystem = require("styled-system");

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getWidth = {
  sm: (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    width: 400px;\n  "]))),
  md: (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    width: 620px;\n  "]))),
  lg: (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    width: 90%;\n  "])))
};

var getAnimation = function getAnimation(_ref) {
  var transitionstate = _ref.transitionstate,
      defaultAnimation = _ref.defaultAnimation,
      _ref$customAnimation = _ref.customAnimation,
      customAnimation = _ref$customAnimation === void 0 ? null : _ref$customAnimation;
  return typeof customAnimation === 'function' ? customAnimation(transitionstate) : defaultAnimation(transitionstate);
};

var OVERLAY_ANIMATION = function OVERLAY_ANIMATION(transitionState) {
  return "\n  opacity: 0;\n  transition: opacity .5s cubic-bezier(0.50, 0.00, 0.25, 1.00);\n  ".concat(transitionState === 'entering' ? "opacity: 0;" : '', "\n  ").concat(transitionState === 'entered' ? "opacity: 1;" : '', "\n  ").concat(transitionState === 'exiting' ? "opacity: 0;" : '', "\n  ").concat(transitionState === 'exited' ? "opacity: 0;" : '', "\n");
};

exports.OVERLAY_ANIMATION = OVERLAY_ANIMATION;

var DIALOG_ANIMATION = function DIALOG_ANIMATION(transitionState) {
  return "\n  transform: scale(0.5);\n  transition: transform .5s cubic-bezier(0.50, 0.00, 0.25, 1.00);\n  ".concat(transitionState === 'entering' ? "transform: scale(0.5);" : '', "\n  ").concat(transitionState === 'entered' ? "transform: scale(1);" : '', "\n  ").concat(transitionState === 'exiting' ? "transform: scale(0.5);" : '', "\n  ").concat(transitionState === 'exited' ? "transform: scale(0.5);" : '', "\n");
};

exports.DIALOG_ANIMATION = DIALOG_ANIMATION;
var Overlay = (0, _styledComponents["default"])(_dialog.DialogOverlay)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: rgba(0, 0, 0, 0.7);\n  bottom: 0;\n  left: 0;\n  ", "\n  position: fixed;\n  right: 0;\n  top: 0;\n  ", "\n  * {\n    box-sizing: border-box;\n  }\n  ", ";\n"])), function (props) {
  return props.enableoverflow && "overflow-y: auto;";
}, function (props) {
  return "\n    z-index: ".concat(props.zindex || 100, ";\n  ");
}, getAnimation);
exports.Overlay = Overlay;
var Dialog = (0, _styledComponents["default"])(_dialog.DialogContent)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  box-shadow: ", ";\n  ", ";\n  padding: ", "px;\n  border-radius: ", ";\n\n  &:focus {\n    outline: none;\n  }\n  ", "\n  ", "\n  ", "\n"])), _styledSystem.color, _styledSystem.height, function (props) {
  return (0, _utils.getShadow)('2')(props);
}, function (props) {
  return props.size && getWidth[props.size];
}, function (props) {
  return props.padding ? "".concat((0, _utils.getSpace)(7)(props)) : '0';
}, function (props) {
  return !props.fullScreen && (0, _utils.getBorderRadius)('tertiary')(props);
}, function (props) {
  return props.fullScreen && "\n    width: 100vw;\n    height: 100vh;\n  ";
}, function (props) {
  return props.enableoverflow && "\n    max-height: none;\n  ";
}, getAnimation);
exports.Dialog = Dialog;

var HeaderWrapper = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  flex-shrink: 0;\n"])));

exports.HeaderWrapper = HeaderWrapper;

var FooterWrapper = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  flex-shrink: 0;\n"])));

exports.FooterWrapper = FooterWrapper;

var ContentWrapper = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  height: 100%;\n  .eui-modal-close {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    z-index: 1;\n  }\n"])));

exports.ContentWrapper = ContentWrapper;

var OverlayWrapper = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  display: table;\n  height: 100%;\n  width: 100%;\n"])));

exports.OverlayWrapper = OverlayWrapper;

var DialogWrapper = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  display: table-cell;\n  vertical-align: ", ";\n  position: relative;\n  height: 100%;\n  ", ";\n"])), function (_ref2) {
  var verticalAlignment = _ref2.verticalAlignment;
  return verticalAlignment;
}, function (props) {
  return props.enableoverflow && "\n    padding-top: 24px;\n    padding-bottom: 24px;\n\n    .d-inner-wrapper {\n      overflow: initial;\n    }\n  ";
});

exports.DialogWrapper = DialogWrapper;

var DialogInnerWrapper = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  height: 100%;\n  overflow: auto;\n"])));

exports.DialogInnerWrapper = DialogInnerWrapper;

var transitionUp = function transitionUp(transitionState) {
  return "\ntransform: translateY(90%);\ntransition: transform 0.3s linear;\n".concat(transitionState === 'entered' ? "transform: translateY(0%);" : '', "\n");
};

exports.transitionUp = transitionUp;

var transitionDown = function transitionDown(transitionState) {
  return "\ntransform: translateY(-90%);\ntransition: transform 0.3s linear;\n".concat(transitionState === 'entered' ? "transform: translateY(0%);" : '', "\n");
};

exports.transitionDown = transitionDown;